import APP from 'src/main.js'
import Event from './Event.js'

class FeePayment extends Event {
  get fee_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='FeeCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get income_received(){
    return (this.fee_cancel||{}).income_received
  }
  get linked(){
    return this.fee_cancel != null
  }

  // FeePayment should only be matched if manual_value is not true
  get should_be_linked() {
    return this.manual_value !== true
  }
}
export default FeePayment
